import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=74065bbc&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=ts"
export * from "./Sound.vue?vue&type=script&lang=ts"
import style0 from "./Sound.vue?vue&type=style&index=0&id=74065bbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74065bbc",
  null
  
)

export default component.exports